import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=5cba727d&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"
import style0 from "./Default.vue?vue&type=style&index=0&id=5cba727d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba727d",
  null
  
)

export default component.exports